import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TimetableComponent } from './timetable/timetable.component';
import { AttendanceCompComponent } from './attendance-comp/attendance-comp.component';
import { NgCalendarModule } from 'ionic2-calendar';

@NgModule({
  declarations: [TimetableComponent, AttendanceCompComponent],
  exports: [TimetableComponent, AttendanceCompComponent],
  imports: [
    CommonModule,
    NgCalendarModule,
    IonicModule
  ]
})
export class SharedComponentsModule { }
